import CostCenterTableCell from './CostCenterTableCell'
export default CostCenterTableCell
